import { render, staticRenderFns } from "./__vet_doctor.vue?vue&type=template&id=5dc47ad0&"
import script from "./__vet_doctor.vue?vue&type=script&lang=js&"
export * from "./__vet_doctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports